module.exports = __webpack_public_path__ + "assets/media/default.f7809773.mp4";